/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Good_Frail_Worm_RoarInputs */

const fr_good_frail_worm_roar = /** @type {(inputs: Good_Frail_Worm_RoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Good_Frail_Worm_RoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const good_frail_worm_roar = /** @type {((inputs?: Good_Frail_Worm_RoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Good_Frail_Worm_RoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_good_frail_worm_roar(inputs)
});